import { createNavigationView } from './index'
import { VIEW_ADVERTISER, VIEW_EMPLOYER } from '../constants'

const ProfileSidebar = () => import('../components/Profile/ProfileSidebar.vue')
const Ratings = () => import('../components/Ratings/Ratings.vue')
const RatingsGiven = () => import('../components/Ratings/RatingsGiven.vue')
const RatingsReceived = () => import('../components/Ratings/RatingsReceived.vue')
const WaitingForRating = () => import('../components/Ratings/WaitingForRating.vue')

export const routes = () => [
  {
    path: '/ertekelesek',
    components: {
      default: Ratings,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Ratings',
      requiresAuth: true,
      requiresValidProfile: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/ertekelesek/ertekeleseim',
    components: {
      default: RatingsGiven,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Ratings - By Me',
      requiresAuth: true,
      requiresValidProfile: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/ertekelesek/engem-ertekeltek',
    components: {
      default: RatingsReceived,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Ratings - On Me',
      requiresAuth: true,
      requiresValidProfile: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/ertekelesek/ertekelesre-var/munkaadok',
    components: {
      default: WaitingForRating,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Ratings - Employers Awaiting',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_ADVERTISER,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/ertekelesek/ertekelesre-var/munkakeresok',
    components: {
      default: WaitingForRating,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Ratings - Advertisers Awaiting',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_EMPLOYER,
      wrapperClass: 'profile-wrapper'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/ratings.js